import { FC, ReactNode } from 'react'
import { CardListType, LoyaltyTierCardList } from './CardList'
import { LoyaltyTierTagList, TagListType } from './TagList'
import { ProviderCard, ProviderCardType } from './ProviderCard'
import { LoyaltyTierTag, LoyaltyTierTagType } from './Tag'
import { ReferralCard, ReferralCardType } from './ReferralCard'

const LoyaltyTier: FC &
  CardListType &
  TagListType &
  ProviderCardType &
  ReferralCardType &
  LoyaltyTierTagType = (): ReactNode => <></>

LoyaltyTier.CardList = LoyaltyTierCardList
LoyaltyTier.TagList = LoyaltyTierTagList
LoyaltyTier.ProviderCard = ProviderCard
LoyaltyTier.Tag = LoyaltyTierTag
LoyaltyTier.ReferralCard = ReferralCard

export default LoyaltyTier
